// CreateOrder.tsx
import React, { useEffect } from 'react';
import { useGetSelfQuery } from '../../../redux/services/MerchantApi';
import { Loading } from '../../../components/Loading/Loading';
import Container from '../../../components/MainContainerWithWindow/Container';
import setFavicon from '../../../utils/setFavIcon';
// @ts-ignore
import styles from './Currency.module.css';
export const Currency = () => {
  const { data, isLoading, error } = useGetSelfQuery();

  useEffect(() => {
    setFavicon('/favicon.svg');
  }, []);

  if (isLoading) return <Loading />;

  if (error || !data) {
    return (
      <Container>
        <div className={styles.card}>
          <p className={styles.error}>Ошибка при загрузке курсов.</p>
        </div>
      </Container>
    );
  }

  return (
    <Container>
      <div className={styles.card}>
          <div className={styles.logoWrapper}>
               <img src={'/logo.svg'} alt={'logo'} className={styles.logo} />
          </div>

        <div className={styles.hybrids}>
          <p className={styles.hybridLine}>
            Гибридный курс (пополнение): <strong>1 USDT = {data.hybrid_deposit_rate.toFixed(2)} RUB</strong>
          </p>
          <p className={styles.hybridLine}>
            Гибридный курс (вывод): <strong>1 USDT = {data.hybrid_withdrawal_rate.toFixed(2)} RUB</strong>
          </p>
        </div>

        <table className={styles.table}>
          <thead>
            <tr>
              <th>Сервис</th>
              <th>Пополнение</th>
              <th>Вывод</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={styles.service}>Rapira</td>
              <td>1 USDT = {data.rapira_deposit_rate.toFixed(2)}</td>
              <td>1 USDT = {data.rapira_withdrawal_rate.toFixed(2)}</td>
            </tr>
            <tr>
              <td className={styles.service}>Bybit</td>
              <td>1 USDT = {data.bybit_deposit_rate.toFixed(2)}</td>
              <td>1 USDT = {data.bybit_withdrawal_rate.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </Container>
  );
};